import { FC } from 'react';
import { Checkbox, Dropdown, Menu } from 'antd';
import { TbCalendarEvent } from 'react-icons/tb';

import { DropdownOptionContent, DropdownPanel, DropdownPanelMenu } from '@/shared/components/dropdowns';
import DropdownButton from '@/shared/components/dropdowns/DropdownButton';

import { FinancialOverviewKeyEventKey } from '../../types';

interface FinancialOverviewKeyEventsDropdownProps {
    onChange: (events: FinancialOverviewKeyEventKey[]) => void;
    value: FinancialOverviewKeyEventKey[];
}

const options: Array<{ description: string; key: FinancialOverviewKeyEventKey; label: string }> = [
    {
        description: 'NBER recession periods and broader macroeconomic contractions.',
        key: 'recessions',
        label: 'Recessions',
    },
    {
        description: 'Company-specific articles and reported market developments.',
        key: 'news',
        label: 'Company News',
    },
    {
        description: 'Historical ex-dividend and distribution dates.',
        key: 'dividends',
        label: 'Dividend Dates',
    },
];

export const FinancialOverviewKeyEventsDropdown: FC<FinancialOverviewKeyEventsDropdownProps> = ({
    onChange,
    value,
}) => {
    const toggle = (key: FinancialOverviewKeyEventKey) => {
        onChange(value.includes(key) ? value.filter((event) => event !== key) : [...value, key]);
    };

    return (
        <Dropdown
            popupRender={() => (
                <DropdownPanel minWidth='20rem'>
                    <DropdownPanelMenu selectable={false}>
                        {options.map((option) => (
                            <Menu.Item
                                key={option.key}
                                onClick={({ domEvent }) => {
                                    domEvent.stopPropagation();
                                    toggle(option.key);
                                }}
                            >
                                <DropdownOptionContent
                                    control={<Checkbox checked={value.includes(option.key)} />}
                                    description={option.description}
                                    selected={value.includes(option.key)}
                                    title={option.label}
                                />
                            </Menu.Item>
                        ))}
                    </DropdownPanelMenu>
                </DropdownPanel>
            )}
            trigger={['click']}
        >
            <DropdownButton icon={<TbCalendarEvent />} size='small'>
                Key Events
                {value.length ? ` (${value.length})` : null}
            </DropdownButton>
        </Dropdown>
    );
};
